// extracted by mini-css-extract-plugin
module.exports = {"logo":"logo-18LsO9Kh","ad_1":"ad_1-2sRfZz5a","ad_2":"ad_2-GMTidEQf"};